import { ApiService } from "./ApiService"

export class OdcService {

    static uri = '/odc';

    static get({ params }) {
        return ApiService.get(this.uri, { 
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
         });
    }

    static show({ id }) {
        return ApiService.get(`${this.uri}/show/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
         });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data,{
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static import({ file }) {
        const formData = new FormData();
        formData.append('file', file);

        return ApiService.post(`${this.uri}/import`, formData, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            },
        });
    }

    static delete({ id }) {
        return ApiService.post(`${this.uri}/delete/${id}`, {},
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}